import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import Zoom from 'react-reveal/Zoom';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import Randomizer from '../components/randomizer';
import OcTanner from '../assets/ads/octanner.jpg';
import Harmons from '../assets/ads/harmons.jpg';
import LivingPlanet from '../assets/ads/living-planet.jpg';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "onegin",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#onegin",
        "aria-label": "onegin permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Onegin`}</h1>
    <h2 {...{
      "id": "ballet-west",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#ballet-west",
        "aria-label": "ballet west permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Ballet West`}</h2>
    <blockquote>
      <p parentName="blockquote">{`🔇 We appreciate you silencing your phone.`}</p>
    </blockquote>
    <small>
      <p>{`All information was published as of October 17th, 2022`}</p>
    </small>
    <Link to="/onegin" mdxType="Link">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQCAwUG/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAWaIoDqlYzQr0qRSZrDP/8QAGxAAAgMBAQEAAAAAAAAAAAAAAQIAAxEhEyL/2gAIAQEAAQUC7r24ZY7LNDvstPzXx4aKjPAxKVI//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHxAAAQQABwAAAAAAAAAAAAAAAQACERIQICEiMjOB/9oACAEBAAY/AiZ8QA1M4SAITairgcvBdLFvYJX/xAAfEAEAAgIBBQEAAAAAAAAAAAABACERMUEQUWGRseH/2gAIAQEAAT8hpmUfSDazBCCm3MSyB3nmUSsErPRqd4rHmotzaBh8i/2ZSfxZ/9oADAMBAAIAAwAAABCbLgz/xAAXEQEBAQEAAAAAAAAAAAAAAAABEQAQ/9oACAEDAQE/EAJwSTTf/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERECH/2gAIAQIBAT8Q7cadKf/EAB8QAQADAAICAwEAAAAAAAAAAAEAESExQVFxYZHR8P/aAAgBAQABPxBtHEkFY6ZVkIhxfcMol5Mi6pdDevjwQdPKpit3XqOoJd/CEOHZUYQ4kNqq4tf2FWzMaLff2mzTRGSuu5//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/onegin-2022/static/3348397cf7bca38304790d8375f111b4/8ac56/onegin-cover.webp 240w", "/onegin-2022/static/3348397cf7bca38304790d8375f111b4/d3be9/onegin-cover.webp 480w", "/onegin-2022/static/3348397cf7bca38304790d8375f111b4/87ca7/onegin-cover.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/onegin-2022/static/3348397cf7bca38304790d8375f111b4/09b79/onegin-cover.jpg 240w", "/onegin-2022/static/3348397cf7bca38304790d8375f111b4/7cc5e/onegin-cover.jpg 480w", "/onegin-2022/static/3348397cf7bca38304790d8375f111b4/1a144/onegin-cover.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/onegin-2022/static/3348397cf7bca38304790d8375f111b4/1a144/onegin-cover.jpg",
              "alt": "onegin cover",
              "title": "onegin cover",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </Link>
    <blockquote>
      <p parentName="blockquote">{`📱 Please use the menu to explore our mobile friendly program.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`📖 If you prefer a traditional “page turning” format as with print publications, `}<a parentName="p" {...{
          "href": "/onegin-2022/digital-program"
        }}>{`please click here`}</a>{`.`}</p>
    </blockquote>
    <h3 {...{
      "id": "quick-navigation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#quick-navigation",
        "aria-label": "quick navigation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Quick Navigation`}</h3>
    <section className="home-list">
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/onegin">
    Onegin
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/sponsors">
    Sponsors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/ballet-west-company">
    Ballet West
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/board-of-directors">
    Board of Directors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/from-the-artistic-director">
    From the Artistic Director
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/from-the-executive-director">
    From the Executive Director
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/wellness-partners">
    Wellness Partners
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/profiles">
    Profiles
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/digital-program">
    Digital Program
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/corporate-foundation-and-government-support">
    Corporate, Foundation, and Government Support
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/individual-donors">
    Individual Donors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/ballet-west-guild">
    Ballet West Guild
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/house-rules">
    House Rules
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/onegin-2022/ballet-west-staff">
    Ballet West Staff
  </a>
      </Zoom>
    </section>
    <br />
    <br />
    <OutboundLink href="https://www.amgseniormedical.com/?utm_source=digital+playbill&utm_medium=ballet_west&utm_campaign=Cover" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUCAwQB/8QAFwEBAQEBAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAABZ5KJQxKys/KYXg1FY1//xAAcEAACAgIDAAAAAAAAAAAAAAAAAQIDERMSFCH/2gAIAQEAAQUC31ppqdkjTaVLjLxnZySvUiOprIxSZ//EABgRAQEAAwAAAAAAAAAAAAAAAAABERIT/9oACAEDAQE/AYw6VvX/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwEh/8QAIRAAAQMCBwEAAAAAAAAAAAAAAAECESExAxASEzIzcaH/2gAIAQEABj8CWXoOdqkTw4i7iQXOv6Vwy+dGyf/EAB0QAQADAAEFAAAAAAAAAAAAAAEAESExUXGRsdH/2gAIAQEAAT8hmULqq64RJhhufmLdLFBLAphLq2NJv2ZpHlOFRbxCnsT/2gAMAwEAAgADAAAAEOgOjP/EABkRAAMAAwAAAAAAAAAAAAAAAAABESExUf/aAAgBAwEBPxBulFtChlI//8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/ELGxhkf/xAAeEAEBAQACAQUAAAAAAAAAAAABEQAhMXFRYYGR0f/aAAgBAQABPxDkjjwFZPjN+QgL+nRjyOtKDQUE93nT3g4AsXWBIgIZEhfL8zksoCtD16xYpLG0cHkMoAEndyYivcm//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/onegin-2022/static/10e53bf51fa519f12cb759a8883b774f/8ac56/amg.webp 240w", "/onegin-2022/static/10e53bf51fa519f12cb759a8883b774f/d3be9/amg.webp 480w", "/onegin-2022/static/10e53bf51fa519f12cb759a8883b774f/87ca7/amg.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/onegin-2022/static/10e53bf51fa519f12cb759a8883b774f/09b79/amg.jpg 240w", "/onegin-2022/static/10e53bf51fa519f12cb759a8883b774f/7cc5e/amg.jpg 480w", "/onegin-2022/static/10e53bf51fa519f12cb759a8883b774f/1a144/amg.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/onegin-2022/static/10e53bf51fa519f12cb759a8883b774f/1a144/amg.jpg",
              "alt": "AMG Senior Medical Group",
              "title": "AMG Senior Medical Group",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>
    <OutboundLink href="https://www.barraesthetics.com/?utm_source=digital+playbill&utm_medium=ballet_west&utm_campaign=Cover" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB6Ky5KNYll0g//8QAGhAAAgMBAQAAAAAAAAAAAAAAABEBECFBQv/aAAgBAQABBQI1KnpB09KK/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGBAAAgMAAAAAAAAAAAAAAAAAARAAIDH/2gAIAQEABj8CmVLL/8QAGxABAQEAAwEBAAAAAAAAAAAAAREAECFBMWH/2gAIAQEAAT8hl0wYeAMd8KEeayw7yi/Ji/mhN7d8f//aAAwDAQACAAMAAAAQxxf+/8QAFxEAAwEAAAAAAAAAAAAAAAAAARARQf/aAAgBAwEBPxCozF//xAAWEQEBAQAAAAAAAAAAAAAAAAAQAWH/2gAIAQIBAT8QJp//xAAdEAEBAAMAAgMAAAAAAAAAAAABEQAhMRBBUYGR/9oACAEBAAE/ENkhvXMG0V+NcygXmFpO40oJfWLWuciqCpkhB+sspr0OEKnQX3q4o019eP/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/onegin-2022/static/849200170a067f160de6eaa65dcfa409/8ac56/barr-aesthetics.webp 240w", "/onegin-2022/static/849200170a067f160de6eaa65dcfa409/d3be9/barr-aesthetics.webp 480w", "/onegin-2022/static/849200170a067f160de6eaa65dcfa409/87ca7/barr-aesthetics.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/onegin-2022/static/849200170a067f160de6eaa65dcfa409/09b79/barr-aesthetics.jpg 240w", "/onegin-2022/static/849200170a067f160de6eaa65dcfa409/7cc5e/barr-aesthetics.jpg 480w", "/onegin-2022/static/849200170a067f160de6eaa65dcfa409/1a144/barr-aesthetics.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/onegin-2022/static/849200170a067f160de6eaa65dcfa409/1a144/barr-aesthetics.jpg",
              "alt": "America First Credit Union",
              "title": "America First Credit Union",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>
    <OutboundLink href="https://www.americafirst.com/?utm_source=digital+playbill&utm_medium=ballet_west&utm_campaign=Cover" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgUD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAD/9oADAMBAAIQAxAAAAFrLeWFEkrQorfTPuJA/wD/xAAgEAABAwMFAQAAAAAAAAAAAAACAAEDERIxBBATFCEi/9oACAEBAAEFAsQ9fwwtKtdPyspPomlVwq4dmKjPn//EABcRAAMBAAAAAAAAAAAAAAAAAAABEhD/2gAIAQMBAT8BeWWf/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQEhP/2gAIAQIBAT8BUZlD/8QAHRAAAgEEAwAAAAAAAAAAAAAAAAEREBIgMjFygv/aAAgBAQAGPwJ9WbEXHk0JGopxh//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESFhMYGRcaH/2gAIAQEAAT8haRA5a9QWeWiN02PyVI1lsB9gUtCp8fZpQccTGYOorTP/2gAMAwEAAgADAAAAEGflPv/EABgRAAMBAQAAAAAAAAAAAAAAAAABERBR/9oACAEDAQE/EMN7IVw//8QAGBEAAgMAAAAAAAAAAAAAAAAAABEQMVH/2gAIAQIBAT8QgisXT//EAB8QAQEAAgIBBQAAAAAAAAAAAAERACExQXFRYYGRof/aAAgBAQABPxBOmClCwjgxaTyeuJluQBXRsxkjWYUEhIpHj2xLAEDY6x28IKkeM37PqxR5fkwjbpnow87+5ogK9EM//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/onegin-2022/static/79b140f335c61509ca20d966e214f58a/8ac56/afcu.webp 240w", "/onegin-2022/static/79b140f335c61509ca20d966e214f58a/d3be9/afcu.webp 480w", "/onegin-2022/static/79b140f335c61509ca20d966e214f58a/87ca7/afcu.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/onegin-2022/static/79b140f335c61509ca20d966e214f58a/09b79/afcu.jpg 240w", "/onegin-2022/static/79b140f335c61509ca20d966e214f58a/7cc5e/afcu.jpg 480w", "/onegin-2022/static/79b140f335c61509ca20d966e214f58a/1a144/afcu.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/onegin-2022/static/79b140f335c61509ca20d966e214f58a/1a144/afcu.jpg",
              "alt": "America First Credit Union",
              "title": "America First Credit Union",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      